import { UneligibleTradeReason, WarnedTradeReason, BlockedTradeReason, blockedTradeReasons } from "@cede/types";
import { formatDuration, intervalToDuration } from "date-fns";

export const getSpecificMessage = (reason: UneligibleTradeReason | undefined): string => {
  if (!reason) return "";
  switch (reason) {
    case WarnedTradeReason.COOLDOWN_VOLUME_REACHED:
      return "You have reached the max user volume by window period.";
    case WarnedTradeReason.MAX_USER_VOLUME_BY_EPOCH_REACHED:
      return "You have reached the max user volume by epoch.";
    case BlockedTradeReason.WALLET_TOO_NEW:
      return "Your wallet must have at least one transaction older than 2 weeks to participate.";
    default:
      return "";
  }
};

export const getUneligibleTradeMessage = (
  reason: UneligibleTradeReason | undefined,
  nextAccessDate: Date | undefined,
): string => {
  const timeUntilNextAccess = nextAccessDate
    ? `You can earn rewards again for this campaign in ${formatDuration(
        intervalToDuration({ start: 0, end: nextAccessDate.getTime() - Date.now() }),
        { format: ["hours", "minutes", "seconds"] },
      )}`
    : "";

  return `${getSpecificMessage(reason)} Your trade will not count towards your rewards. ${timeUntilNextAccess}`;
};

export const shouldReasonBlockTrading = (reason?: UneligibleTradeReason): reason is BlockedTradeReason => {
  if (!reason) return false;
  return blockedTradeReasons.has(reason);
};
